import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../Common/DataTable';
import { Cancel } from '../../media/images/Cancel';
import { Datatablestyle } from './utils/Constant';
import { getAssociatedBidsStart, moveJobOrder } from '../Job/jobStarter/addJob/redux/addJobSlice';
import { BidsData } from '../Job/jobStarter/addJob/utils/types';
import { bidsColumns } from '../Job/jobStarter/addJob/utils/constants';
import { formatBidListingData } from '../Job/jobStarter/addJob/utils/helper';
import { RootState } from '../../redux/rootState';
import { setLoader } from '../../redux/loaderSlice';
import ConfirmationModal from '../../Common/ConfirmationModal/ConfirmationModal';
import { ConfirmationIcon } from '../../assets/Icons/AnalystIcons/ConfirmationIcon';
import { defaultPageSize } from '../../utils/Constant';

interface IBidReportDetailsModal {
  open: string;
  handleClose: () => void;
  handleSuccess: () => void;
  selectedUnit: string;
}

export default function BidByJobModal({
  open, handleClose, selectedUnit, handleSuccess,
}: IBidReportDetailsModal) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  const [openConfirm, setOpenConfirm] = useState('');
  const { bidList, totalBids, isLoading } = useSelector((state: RootState) => state.jobStarterReducer);

  const handleData = () => {
    const payload = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
      jobId: open,
    };
    dispatch(getAssociatedBidsStart(payload));
  };

  useEffect(() => {
    if (open?.length > 0) {
      handleData();
    }
  }, [open, page, rowsPerPage, searchQuery, sortCol, sortDir]);
  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const closeModal = () => {
    // dispatch(resetJobStarterState());
    handleClose();
  };
  const successRun = () => {
    handleSuccess();
    closeModal();
  };
  const handleConfirm = () => {
    // api call
    const pay = {
      jobOrder: selectedUnit,
      bidId: openConfirm,
    };
    dispatch(moveJobOrder({ pay, callback: successRun }));
    setOpenConfirm('');
  };

  return (
    <>
      <Modal
        open={open?.length > 0}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Datatablestyle}>
          <div className="customerInfo_container flex-row">
            <div className="customerInfo">
              Bids for Job:
              {' '}
              {open}
            </div>
            <div className="cancel-icon" style={{ cursor: 'pointer' }} onClick={() => closeModal()}>
              <Cancel />
            </div>

          </div>
          <DataTable<BidsData>
            data={formatBidListingData(bidList, true)}
            columns={bidsColumns}
            totalRecords={totalBids}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            searchQuery={searchQuery}
            setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
            sortCol={sortCol}
            setSortCol={(e) => { setSortCol(e); setPage(1); }}
            sortDir={sortDir}
            setSortDir={(e) => { setSortDir(e); setPage(1); }}
            handleData={handleData}
            handleLinkMove={(id) => setOpenConfirm(id)}
            handleDataFromComponent
          />
        </Box>
      </Modal>
      {openConfirm && (
      <ConfirmationModal
        show={openConfirm?.length > 0}
        setOpenFrom={() => setOpenConfirm('')}
        handleConfirmation={handleConfirm}
        confirmationIcon={<ConfirmationIcon />}
        text={`Are you sure you want to move the unit ${selectedUnit} to ${openConfirm} ?`}
      />
      )}
    </>
  );
}
